/* eslint-disable @typescript-eslint/no-this-alias */
import React, { useState, useEffect, useMemo } from 'react';
import { Box, Pagination, Skeleton } from '@mui/material';
import SortDropdown from '../../common/dropdowns/SortDropdown.jsx'
import ButtonFilters from '../../common/buttons/ButtonFilters.jsx'
import FiltersCard from '../../common/filters/FiltersCard.jsx'
import Search from '../../common/inputs/Search.jsx'
import RequestsHotelsList from './RequestsHotelsList.jsx'
import { styled } from '@mui/material/styles';
import { useTranslation } from 'react-i18next';
import { useAppStore } from '../../../../stores/useAppStore';
import { useStoreVolet } from '../requests_hotels/stores/storeVolet.js';

const FiltersActions = styled(Box)({
    display: 'flex',
    alignItems: 'center',
    'a, button': {
        marginRight: '13px !important'
    }
});

export default function RequestsHotelsContentSimple({
    from = 'volet',
    view = 'list',
    clientId = null,
    companyId = null,
    frameworkAgreementId = null,
}){

    let AJAX_GETTER_BASE_URL = `${ENV.base_lang_url}myspace/`;
    if ( 'hotelier' == AUTH.frontloginas ) AJAX_GETTER_BASE_URL += 'providers';
    else if ( 'client' == AUTH.frontloginas ) AJAX_GETTER_BASE_URL += 'clients';
    AJAX_GETTER_BASE_URL += '//ajaxGetter/';

    const { account, instance } = useAppStore();
    const {
        isLoaded,
        getRequestsHotels,
        requestsHotels,
        max,
        sorting,
        search,
        date1ListSelected,
        date2ListSelected,
        dateCustom,
        statusListSelected,
        sourcesListSelected,
        budgetSelected,
        hotelsListSelected,
        segmentsListSelected,
        frameworkAgreementsListSelected,
        customersViewsSelected,
        withAccommodationsSelected,
        withMeetingRoomsSelected,
        handleSearch,
        sortingChange,
        filterClear,
        filterChange,
        setClientId,
        setCompanyId,
        setFrameworkAgreementId,
        constructParams,
        parameters,
        clear,
        pagination,
        changePage
    } = useStoreVolet();

    const sortingOptions = [
        {
            'value': 'default',
            'label': 'default'.trad()
        },
        {
            'value': 'checkin',
            'label': 'checkin'.trad()
        },
        {
            'value': 'budget',
            'label': 'budget'.trad()
        },
        {
            'value': 'task_date',
            'label': 'task_date'.trad()
        },
        {
            'value': 'customers_views',
            'label': 'customers_views'.trad()
        },
        {
            'value': 'next_echeance',
            'label': 'next_echeance'.trad()
        }
    ];

    const [sourcesList, setSourcesList] = useState([]);
    const [hotelsList, setHotelsList] = useState([]);
    const [segmentsList, setSegmentsList] = useState([]);
    const [frameworkAgreementsList, setFrameworkAgreementsList] = useState([]);
    const [budgetRange, setBudgetRange] = useState([]);
    const [openFilters, setOpenFilters] = useState(false);
    const [loadedFilters, setLoadedFilters] = useState([]);
    const [isFiltersLoaded, setIsFiltersLoaded] = useState(false);

    useEffect(() => {
        clear();
        setClientId(clientId);
        setCompanyId(companyId);
        setFrameworkAgreementId(frameworkAgreementId);
        getRequestsHotels();
        setOpenFilters(false);
    }, []);
    
    let filters = [];
    
    if ( !(!!frameworkAgreementId && 'client' == AUTH.frontloginas) ) {

        useEffect(() => {
            Promise.all([fetch(`${AJAX_GETTER_BASE_URL}get_sources`)])
            .then(([res1]) => {return Promise.all([res1.json()])})
            .then(([res1]) => {
                setSourcesList(res1);
                filters = [...filters, 'sourcesList'];
                setLoadedFilters(filters);
            })
        }, []);

        useEffect(() => {
            Promise.all([fetch(`${AJAX_GETTER_BASE_URL}get_hotels_proprietaire`)])
            .then(([res1]) => {return Promise.all([res1.json()])})
            .then(([res1]) => {
                setHotelsList(res1);
                filters = [...filters, 'hotelsList'];
                setLoadedFilters(filters);
            })
        }, []);

        useEffect(() => {
            Promise.all([fetch(`${AJAX_GETTER_BASE_URL}get_segments_list`)])
            .then(([res1]) => {return Promise.all([res1.json()])})
            .then(([res1]) => {
                setSegmentsList(res1);
                filters = [...filters, 'segmentsList'];
                setLoadedFilters(filters);
            })
        }, []);

    } // endif

    
    useEffect(() => {
        if ( account?.rights.includes('framework_agreements') ) {
            let url = new URL(`${AJAX_GETTER_BASE_URL}get_framework_agreements_list`);
            if ( companyId ) url.searchParams.append('company_id', companyId);
            if ( clientId ) url.searchParams.append('client_id', clientId);
            if ( frameworkAgreementId ) url.searchParams.append('id', frameworkAgreementId);

            Promise.all([fetch(url.toString())])
            .then(([res1]) => {return Promise.all([res1.json()])})
            .then(([res1]) => {
                setFrameworkAgreementsList(res1);
                filters = [...filters, 'frameworkAgreementsList'];
                setLoadedFilters(filters);
            })
        } // endif

    }, [account]);
    

    useEffect(() => {
        Promise.all([fetch(`${AJAX_GETTER_BASE_URL}get_budget_range/requests_hotels`)])
        .then(([res1]) => {return Promise.all([res1.json()])})
        .then(([res1]) => {
            setBudgetRange(res1);
            filters = [...filters, 'budgetRange'];
            setLoadedFilters(filters);
        })
    }, []);

    useEffect(() => {
        setIsFiltersLoaded(true);
    }, [loadedFilters]);

    const hasFilters = useMemo(() => (
        (sorting != '' && sorting != 'default' ) ||
        date1ListSelected != '' ||
        date2ListSelected != '' ||
        statusListSelected != '' ||
        budgetSelected != '' ||
        sourcesListSelected != '' ||
        hotelsListSelected != '' ||
        segmentsListSelected.length ||
        (!frameworkAgreementId && frameworkAgreementsListSelected.length) ||
        withAccommodationsSelected != 'all' ||
        withMeetingRoomsSelected != 'all'
    ), [requestsHotels, sorting, date1ListSelected, date2ListSelected, statusListSelected, budgetSelected, sourcesListSelected, hotelsListSelected, segmentsListSelected, frameworkAgreementId, frameworkAgreementsListSelected, withAccommodationsSelected, withMeetingRoomsSelected]);

	return (
		<div>
            { !isFiltersLoaded ? (
                <Skeleton
                    className="card bg-gc-light-blue-dark border-none mb-3"
                    variant="rectangular"
                    width="100%"
                    height={40}
                />
            ) : (
                <div className="mb-3">
                    <div className="d-flex justify-content-between align-items-center">
                        <FiltersActions>
                            <span className="d-inline-block">
                                <SortDropdown 
                                    parentFunction={sortingChange} 
                                    options={sortingOptions}
                                    selectedOption={sorting}
                                    disabled={view == 'calendar' ? true : false}
                                />
                            </span>
                            <span className="d-inline-block">
                                <ButtonFilters 
                                    open={openFilters} 
                                    hasFilters={hasFilters}
                                    onToggleCollapse={(value) => setOpenFilters(value)}
                                    onFiltersClear={filterClear}
                                />
                            </span>
                            <span className="d-none d-md-inline-block text-gc-dark-blue font-weight-bold">
                                { isLoaded ?
                                    'nb_results'.trad().replace('%1', max)
                                    :
                                    'nb_results'.trad().replace('%1', '-')
                                }
                            </span>
                        </FiltersActions>

                        <div className='d-flex align-items-center'>
                            <span className="ml-4"><Search value={search} onChangeFunction={handleSearch}/></span>
                        </div>
                    </div>
                </div>
            )}

			<div>
                { !isFiltersLoaded && hasFilters ? (
                    <Skeleton 
                        className="card bg-gc-light-blue-dark border-none mb-3" 
                        variant="rectangular" 
                        width="100%" 
                        height={278} 
                    />
                ) : (
                    <FiltersCard
                        open={openFilters}
                        parentFunction={filterChange}
                        inputs={[
                            {
                                'slug': 'date',
                                'label': 'date',
                                'data1': filterDate1Options,
                                'selectedItems1': date1ListSelected,
                                'data2': filterDate2Options,
                                'selectedItems2': date2ListSelected,
                                'autoTrad': true,
                                'type': 'selectDate',
                                'order': 1,
                                'custom': date2ListSelected === 'custom',
                                'periodChoice': true,
                                'selectedDates': dateCustom
                            },
                            {
                                'slug': 'status',
                                'label': 'statut',
                                'selectedItems': statusListSelected,
                                'type': 'StatusRequestHotelAccommodation',
                                'route': 'get_status_requests_hotels_accommodation/venue/all',
                                'hide': !!frameworkAgreementId && 'client' == AUTH.frontloginas,
                                'order': 2
                            },
                            {
                                'slug': 'budget',
                                'label': 'volume_daffaire',
                                'type': 'range',
                                'min': budgetRange[0],
                                'max': budgetRange[1],
                                'selectedValue': budgetSelected,
                                'order': 3,
                                'hide': !!frameworkAgreementId && 'client' == AUTH.frontloginas,
                            },
                            {
                                'slug': 'sources',
                                'label': 'source',
                                'data': sourcesList,
                                'selectedItems': sourcesListSelected,
                                'autoTrad': true,
                                'type': 'multipleSelect',
                                'order': 4,
                                'hide': !!frameworkAgreementId && 'client' == AUTH.frontloginas,
                            },
                            {
                                'slug': 'hotels',
                                'label': 'etablissement',
                                'data': hotelsList,
                                'selectedItems': hotelsListSelected,
                                'autoTrad': false,
                                'type': 'multipleSelect',
                                'order': 5,
                                'hide': !!frameworkAgreementId && 'client' == AUTH.frontloginas,
                            },
                            {
                                'slug': 'segments',
                                'label': 'segments',
                                'data': segmentsList,
                                'selectedItems': segmentsListSelected,
                                'autoTrad': false,
                                'type': 'multipleSelect',
                                'order': 6,
                                'hide': (instance?.segmentationActive == 1 && segmentsList.length > 0 ? false : true) && (!!frameworkAgreementId && 'client' == AUTH.frontloginas),
                            },
                            {
                                'slug': 'framework_agreements',
                                'label': 'framework_agreements',
                                'data': frameworkAgreementsList,
                                'selectedItems': frameworkAgreementsListSelected,
                                'autoTrad': false,
                                'type': 'multipleSelect',
                                'order': 7,
                                'hide': !account?.rights.includes('framework_agreements') || !!frameworkAgreementId,
                            },
                            {
                                'slug': 'customers_views',
                                'label': 'vues_clients',
                                'options': filterCustomerViewOptions,
                                'selected': customersViewsSelected,
                                'type': 'radio',
                                'autoTrad': true,
                                'order': 8,
                            },
                            {
                                'slug': 'with_accommodations',
                                'label': 'avec_sans_hebergement',
                                'options': filterWithoutAccommodationOptions,
                                'selected': withAccommodationsSelected,
                                'type': 'radio',
                                'autoTrad': true,
                                'order': 9,
                                'hide': !!frameworkAgreementId && 'client' == AUTH.frontloginas,
                            },
                            {
                                'slug': 'with_meeting_rooms',
                                'label': 'avec_sans_salle_de_reunion',
                                'options': filterWithoutAccommodationOptions,
                                'selected': withMeetingRoomsSelected,
                                'type': 'radio',
                                'autoTrad': true,
                                'order': 10,
                                'hide': !!frameworkAgreementId && 'client' == AUTH.frontloginas,
                            }
                        ]}
                    />
                )}
			</div>

			<div className="mb-3">
                <RequestsHotelsList 
                    from={from}
                    showTitle={true}
                    showManager={true}
                    showBudget={true}
                    badgeBgColor={'light'}
                    isLoaded={isLoaded}
                    view={view}
                    getRequestsHotels={getRequestsHotels}
                    requestsHotels={requestsHotels}
                    max={max}
                    constructParams={constructParams}
                    parameters={parameters}
                />
                {pagination.hasPagination && <Pagination count={pagination?.lastPage} variant="outlined" shape="rounded" onChange={(event, number) => changePage(number)} />}
			</div>
		</div>
	);
}

const filterDate1Options = [
    {
        'value': 'checkin',
        'label': 'checkin_date'
    },
    {
        'value': 'request',
        'label': 'request_date'
    }
];

const filterDate2Options = [
    {
        'value': 'today',
        'label': 'today'
    },
    {
        'value': 'tomorrow',
        'label': 'tomorrow'
    },
    {
        'value': 'this_week',
        'label': 'this_week'
    },
    {
        'value': 'next_week',
        'label': 'next_week'
    },
    {
        'value': 'this_month',
        'label': 'this_month'
    },
    {
        'value': 'next_month',
        'label': 'next_month'
    },
    {
        'value': 'custom',
        'label': 'date_custom'
    }
];

const filterCustomerViewOptions = [
    {
        'slug': 'all',
        'label': 'all_filter'
    },
    {
        'slug': 'view',
        'label': 'view'
    },
    {
        'slug': 'no_view',
        'label': 'no_view'
    }
];

const filterWithoutAccommodationOptions = [
    {
        'slug': 'all',
        'label': 'all_filter'
    },
    {
        'slug': 'with',
        'label': 'with'
    },
    {
        'slug': 'without',
        'label': 'without'
    }
];
